export class SearchTerm {
    constructor(
        public fieldName: string,
        public targetValue?: string | number | null,
        public targetRangeMin?: number | null,
        public targetRangeMax?: number | null
    ) { }
}